module.exports = __webpack_public_path__ + "./Joanna_c1e65d4043bf3a75ee8a4d1e3475ed51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2020/Joanna.jpg
// module id = 494
// module chunks = 0